"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventRsvpBlastRequestDto = void 0;
const swagger_1 = require("@nestjs/swagger");
class EventRsvpBlastRequestDto {}
exports.EventRsvpBlastRequestDto = EventRsvpBlastRequestDto;
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Push title (bold first line), ≤ 65 characters.'
}), __metadata("design:type", String)], EventRsvpBlastRequestDto.prototype, "title", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Push body, ≤ 240 characters.'
}), __metadata("design:type", String)], EventRsvpBlastRequestDto.prototype, "message", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'Skip people who already hold a ticket for this event. Default true.'
}), __metadata("design:type", Boolean)], EventRsvpBlastRequestDto.prototype, "excludeTicketHolders", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'Also send to internal (team / test) users. Default false.'
}), __metadata("design:type", Boolean)], EventRsvpBlastRequestDto.prototype, "includeInternal", void 0);
//# sourceMappingURL=EventRsvpBlast.dto.js.map